"use client";

import { Repeat2 } from "lucide-react";
import { useTranslations } from "next-intl";

import { cn } from "@/lib/utils";

/**
 * `EX-RTW03`, board D: the "Runs twice" tag beside a run-twice problem's
 * title, on its page, in the library and on a contest's problem list. The
 * accent's soft fill, as the plan draws it, so it reads as a property of the
 * problem rather than a status. Rendered only for a run-twice problem; a
 * standard one never meets it.
 */
export function RunTwiceTag({ className, size = "md" }: { className?: string; size?: "sm" | "md" }) {
  const t = useTranslations("judge.runTwice");
  return (
    <span
      className={cn(
        "inline-flex shrink-0 items-center gap-1 whitespace-nowrap rounded-full border border-primary/25 bg-primary/[0.08] font-semibold text-primary-ink",
        size === "sm" ? "px-2 py-0.5 text-[11px]" : "px-2.5 py-0.5 text-xs",
        className,
      )}
      title={t("tagTitle")}
      data-testid="run-twice-tag"
    >
      <Repeat2 className={size === "sm" ? "h-3 w-3" : "h-3.5 w-3.5"} aria-hidden />
      {t("tag")}
    </span>
  );
}
